var _excluded = ["aria-label", "children", "className", "disabled", "icon", "iconOnRight", "minor", "onClick", "variant", "withoutIcon"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useRef } from "react";
import { BUTTON_VARIANT, Button, buttonDefaultProps, buttonTypes } from "#library/components/Button";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
import IconMoreActions from "#library/assets/icons/jds_moreActions.svg";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
import { hideDropdownMenu, setTriggerButton, showDropdownMenu } from "#library/components/Dropdown/Dropdown.actions";
export var defaultProps = _objectSpread(_objectSpread({}, buttonDefaultProps), {}, {
  "aria-label": "Dropdown button",
  iconOnRight: true,
  minor: false,
  onClick: function onClick() {}
});
export var TriggerButton = function TriggerButton(props) {
  var ariaLabel = props["aria-label"],
    children = props.children,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    icon = props.icon,
    _props$iconOnRight = props.iconOnRight,
    iconOnRight = _props$iconOnRight === void 0 ? true : _props$iconOnRight,
    _props$minor = props.minor,
    minor = _props$minor === void 0 ? false : _props$minor,
    onClick = props.onClick,
    variant = props.variant,
    withoutIcon = props.withoutIcon,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var triggerRef = useRef();
  useEffect(function () {
    var triggerButton = triggerRef.current;
    dispatch(setTriggerButton(triggerButton));
  }, [dispatch]);
  var toggleDropdownMenu = function toggleDropdownMenu(event) {
    if (disabled) return;
    if (onClick) {
      onClick(event);
    }
    if (state.isDropdownMenuVisible) {
      dispatch(hideDropdownMenu());
    } else {
      dispatch(showDropdownMenu());
    }
  };
  if (!children) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
      "aria-expanded": state.isDropdownMenuVisible,
      "aria-haspopup": "true",
      "aria-label": ariaLabel,
      className: className,
      disabled: disabled,
      icon: IconMoreActions,
      minor: minor !== null && minor !== void 0 ? minor : true,
      onClick: function onClick(event) {
        toggleDropdownMenu(event);
      },
      ref: triggerRef,
      variant: variant !== null && variant !== void 0 ? variant : BUTTON_VARIANT.NAKED
    }));
  }
  return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
    "aria-expanded": state.isDropdownMenuVisible,
    "aria-haspopup": "true",
    className: className,
    disabled: disabled,
    icon: icon || IconArrowDown,
    iconOnRight: iconOnRight,
    minor: minor,
    onClick: function onClick(event) {
      toggleDropdownMenu(event);
    },
    ref: triggerRef
  }), children);
};
TriggerButton.propTypes = buttonTypes;